<template>
 <div :class="windowClass">
        <v-row no-gutters >
            
             <v-col sm="12" class="pa-1">
                 <v-card>
                        <v-card-title>
                            <v-icon left color="primary">mdi-file-document-box-multiple-outline</v-icon> LEDGER
                            <v-divider class="ml-2" inset vertical/>
                            
                            <v-spacer/>
                            <v-spacer/>
                            <v-spacer/>
                     
                        <span style="width: 100px; margin-right: 6px;">
                            <v-autocomplete
                               v-model="customer_type"
                               :items="['ALL', 'CASH', 'CREDIT']"
                               label="Type"
                                dense
                             hide-details
                               single-line
                            />
                        </span>
                        <v-autocomplete 
                            :items="FilterCustomers"
                            v-model="customer"
                           @change="account={}, Transactions=[], selected_date=$moment().format('YYYY-MM-DD'),selected_date2=$moment().format('YYYY-MM-DD'),  getTotal(), getTransactions()"
                            dense
                             hide-details
                               single-line
                            item-text="firstname"
                            item-value="id"
                            return-object=""
                            label="Select Customers"
                        />
                        </v-card-title>
                        
                        <v-card-text class="mt-10">
                             <v-row class="ma-1">
                                  <v-icon class="ma-1" color="secondary" @click="lock = !lock">mdi-{{lock?'lock':'lock-open-variant'}}</v-icon>
                                  <v-icon class="ma-1" color="primary" @click="showform=true, state='new'" title="add">mdi-file-document-box-plus</v-icon>
                                <v-spacer/>
                                <v-card class="elevation-0" width="220"> 
                                  <v-menu
                                  ref="menu"
                                  v-model="datemenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="600px"
                              >
                                  <template v-slot:activator="{ on }">
                                  <v-text-field
                                      :value="selected_date +' - '+selected_date2"
                                      label="select date range"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      dense
                                      single-line
                                      class="mr-2 sm-width"
                                      hide-details
                                      v-on="on"
                                  ></v-text-field>
                                  </template>
                                  <v-date-picker class="ma-1" v-model="selected_date" no-title scrollable @input="Transactions=[]" />
                                   <v-date-picker class="ma-1" v-model="selected_date2" no-title scrollable @input="datemenu = false, Transactions=[], getTransactions()" />
                                 
                              </v-menu>
                                </v-card>
                                <v-card class="elevation-0" width="100">
                                  <v-select
                                    dense
                                      single-line
                                      hide-details
                                  v-model="view"
                                  :items="['All', 'Collectible','Payment', 'SC payment', 'TF payment']"
                                  />
                                   </v-card>
                            </v-row>
                              <v-divider />
                        <v-data-table
                        :headers="headers"
                        dense
                        class="va-table"
                        :items="FILTEREDTRANSACTIONS"
                         :items-per-page="10"
                        >
                           >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index" :class="type[item.type]">
                                        <td>
                                            <v-icon small color="error" @click="transaction = item,confirm=true" v-if="!lock">mdi-delete</v-icon> 
                                            <!-- <v-icon small color="warning" v-if="!lock" left>mdi-pencil</v-icon>  -->
                                        {{item.id}}
                                        </td>
                                        <td>{{item.remarks}}</td>
                                        <td>{{ type[item.type] }}</td>
                                        <td>{{ item.trans_date | moment("lll") }} </td>
                                        <td>{{ item.reference }} </td>
                                        <td><v-chip small color="success" class="mt-1 mb-1">{{ item.status }} </v-chip> </td>
                                        <td class="text-right">{{ $money(item.amount) }} </td>
                                    </tr>
                                    </tbody>
                                </template>
                        
                        </v-data-table>
                        </v-card-text>
                           
                        <v-card-actions class="body-2 pa-4">
                            <v-spacer/>
                             DATE: {{selected_date}} - {{selected_date2}}
                             <v-divider vertical class="ml-2 mr-2"/>
                              SALES: {{ $money(SALES_AMOUNT) }}
                              <v-divider  vertical class="ml-2 mr-2"/>
                             PAYMENTS: {{ $money(PAYMENT_AMOUNT) }}
                              <v-divider  vertical class="ml-2 mr-2"/>
                             COLLECTIBLES: {{ $money(COLLECTIBLES) }} 
                        </v-card-actions>
                    </v-card>
            </v-col>
        </v-row>

    <v-row  no-gutters class="mt-10 body-2 text-center">
        <v-col md="4" class="pa-1">
            <v-icon left color="secondary">mdi-cart</v-icon> <span class="va-underline">TOTAL SALES </span><br /> 
            <span>{{$money(account.collectible)}}</span>
        </v-col>  
        <v-col md="4" class="pa-1">
            <v-icon left color="secondary">mdi-bank-transfer-in</v-icon> <span class="va-underline">TOTAL PAYMENTS</span> <br /> 
            <span>{{$money(account.payout)}}</span>
        </v-col>
        <v-col md="4" class="pa-1">
            <v-icon left color="secondary">mdi-account-cash</v-icon> <span class="va-underline">TOTAL COLLECTIBLES</span><br /> 
            <span>{{$money(TOTAL_CURRENT_COLLECTIBLE)}}</span>
        </v-col>
    </v-row>


    <va-payable-form :show="showform" :accounts="Customers" :account_type="3" @DialogEvent="formEvent"/>
    <va-confirm :show="confirm" cancelbtn="No" okbtn="Delete" text="Would you like to delete this transaction?" @DialogEvent="cEvent"/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        lock: true,
        view: 'All',
        customer_type: 'ALL',
        confirm: false,
        showform: false,
        search:'',
        datemenu: false,
        datemenu2: false,
        selected_date:'',
        selected_date2:'',
        state:'new',
        Customers:[],
        customer:{},
        account: {},
        transaction:{},
        Transactions:[],
        headers:[
           {text: 'ID', value: 'id', sortable: false},
            {text: 'Transaction', value: 'remarks'},
            {text: 'Type', value: 'type'},
            {text: 'Date', value: 'trans_date'},
            {text: 'Ref ID', value: 'reference'},
            {text: 'Status', value: 'status'},
            {text: 'Amount', value: 'amount', align: "right"},
        ],
        type: ['','collectible','payable', 'payout', 'payment', 'sc payment', 'tf payment']
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getCustomers()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      FilterCustomers() {
        if(this.customer_type == "CREDIT") { 
            let arrCust =  this.Customers.reduce((res, item) =>{
                    if(item.credit == 'enabled' && item.parent ==0) {
                        res.push(item)
                    }
                    return res
                }, [])
              return arrCust
        } else if(this.customer_type == "CASH") { 
            let arrCust =  this.Customers.reduce((res, item) =>{
                    if(item.credit != 'enabled') {
                        res.push(item)
                    }
                    return res
                }, [])
              return arrCust
        } else {
            return this.Customers
        }
      },
      PAYMENT_AMOUNT() {
          var arr = this.Transactions
           let total = arr.reduce((a, o) => o.type>=4?a += this.$IsNum(o.amount):a+=0, 0)
           return total
      },
       SALES_AMOUNT() {
          var arr = this.Transactions
           let total = arr.reduce((a, o) => o.type==1?a += this.$IsNum(o.amount):a+=0, 0)
           return total
      },
      COLLECTIBLE_AMOUNT() {
          var arr = this.Transactions
           let total = arr.reduce((a, o) => o.type==1?a += this.$IsNum(o.amount):a+=0, 0)
           return total
      },
      COLLECTIBLES() {
          return this.SALES_AMOUNT - this.PAYMENT_AMOUNT
      },
      TOTAL_CURRENT_COLLECTIBLE() {
        return this.$IsNum(this.account.collectible) - this.$IsNum(this.account.payout)
      },
      FILTEREDTRANSACTIONS(){
       
        if(this.view == 'Collectible') {
                let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 1) {
                          res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(this.view == 'Payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 4) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(this.view == 'SC payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 5) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(this.view == 'TF payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 6) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           }  else {
               return  this.Transactions
           }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      cEvent(data){
        this.confirm = false
        if('ok' == data) {
          this.deleteTransaction()
        }
      },
      formEvent(data){
        console.log(data)
        this.showform =false
        this.getTransactions()
        this.getTotal()
      },
      deleteTransaction(){
           this.$http.post("transaction/delete", this.transaction).then(response => {
              response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('error', response.data.message)
              this.getTransactions()
         }).catch(e => {
           console.log(e.data)
         })
      },
      getTotal(){
        this.$http.post("transaction/query_total", {account: this.customer.id, account_type: 3}).then(response => {
              response.data.data != null?this.account = response.data.data:this.account={}
              console.log(this.account)
         }).catch(e => {
           console.log(e.data)
         })
     },
       getTransactions(){
        this.$http.post("transaction/query", {account: this.customer.id, account_type: 3, start_date: this.selected_date, end_date: this.selected_date2}).then(response => {
              response.data.data != null?this.Transactions = response.data.data:this.Transactions=[]
         }).catch(e => {
           console.log(e.data)
         })
     },
       getCustomers() {
         this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.Customers = response.data.data:this.Customers=[]
          }).catch(e => {
           console.log(e.data)
         })
       }
     }
  }
</script>
<style>
  .payable {
    
  }
  .collectible {
    color: #19365A;
  }
  .payout, .payment {
    color: #5cb860;
  }
</style>
